import styled from '@emotion/styled';
import {
  inputLabelClasses,
  InputLabel as MuiInputLabel,
  type InputLabelProps as MuiInputLabelProps,
} from '@mui/material';
import { CommonLabelSeparateProps } from './types';
import { textVariant } from 'components/text';

interface InputLabelProps
  extends MuiInputLabelProps,
    Pick<CommonLabelSeparateProps, 'labelVariant' | 'isUnderline' | 'labelWeight' | 'labelColor'> {}

export const InputLabel = ({ ...props }: InputLabelProps) => {
  return <StyledInputLabel {...props} />;
};

const StyledInputLabel = styled(
  ({ labelVariant, isUnderline, labelWeight, labelColor, ...props }: InputLabelProps) => (
    <MuiInputLabel {...props} />
  )
)(({
  theme,
  isUnderline = false,
  labelVariant = 'labelSm',
  labelWeight = 'regular',
  labelColor,
}) => {
  const labelStyleBase =
    (theme.typography?.[labelVariant as keyof typeof theme.typography] as Record<string, string>) ??
    {};
  const resolvedLabelStyle = typeof labelStyleBase === 'string' ? {} : labelStyleBase;
  return {
    // Base styles
    '&.MuiInputLabel-root': {
      color: labelColor ?? theme.palette.text.placeholder,
      ...resolvedLabelStyle,
      ...(textVariant?.[labelWeight] ?? {}),
      ...(isUnderline && { textDecoration: 'underline' }),
    },

    [`.${inputLabelClasses.error}`]: {
      color: theme.palette.text.error,
    },

    [`& .${inputLabelClasses.asterisk}`]: {
      color: theme.palette.text.error,
    },
  };
});
